/**
 * Created by slava on 24.03.17.
 */

const HeroWindow = CleverappsWindow.extend({
    onWindowLoaded: function (options) {
        this.heroColor = options.color;
        this.heroLevel = match3.heroes.getLevel(this.heroColor);

        this.type = options.type;

        if (options.type) {
            this.type = options.type;
        } else if (match3.heroes.isMaxLevel(this.heroColor)) {
            this.type = "info";
        } else if (this.heroLevel > 0) {
            this.type = "upgrade";
        } else {
            this.type = "unlock";
        }

        this.expPrice = match3.heroes.expUpgradePrice(this.heroColor);
        this.coinPrice = match3.heroes.coinUpgradePrice(this.heroColor);

        const styles = cleverapps.styles.HeroWindow;
        const content = this.generateContent();

        const title = Messages.get(`HeroWindow.title.${this.type}`);

        const button = {
            width: styles.button.width,
            height: styles.button.height,
            text: Messages.get("OK"),
            onPressed: this.close.bind(this)
        };

        const canBuyExp = cleverapps.exp.canTakeExp(this.expPrice) || cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_REGULAR;
        if (canBuyExp) {
            if (this.type === "unlock") {
                button.text = Messages.get("Heroes.Unlock.Button");
                button.onPressed = this.upgrade.bind(this);
            } else if (this.type === "upgrade") {
                button.text = Messages.get("Heroes.Upgrade.Button");
                button.onPressed = this.upgrade.bind(this);
            }
        }

        this._super({
            title,
            name: "herowindow",
            content,
            button,
            openSound: (this.type === "upgrade" || this.type === "unlock") ? bundles.hero_window.urls.upgrade_effect : undefined,
            help: cleverapps.config.name === "riddles" && function () {
                cleverapps.focusManager.display({
                    focus: "HeroGuideWindow",
                    stack: true,
                    action: (f) => {
                        new GuideWindow({
                            name: "HeroGuideWindow",
                            bundle: bundles.hero_guide_window
                        });
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }
        });

        if (cleverapps.forces.isRunningForce()) {
            this._setGlobalZOrder(true);
        }
    },

    upgrade: function () {
        if (cleverapps.exp.canTakeExp(this.expPrice)) {
            if (levels.user.spendHard(cleverapps.EVENTS.SPENT.HERO_UPGRADE, this.coinPrice)) {
                cleverapps.exp.takeExp(this.expPrice);

                match3.heroes.incLevel(this.heroColor);

                this.close();

                cleverapps.tutorial.trigger("upgrade_hero");
            }

            return;
        }

        cleverapps.focusManager.display({
            focus: "ExpInfoWindow",
            stack: true,
            action: (f) => {
                new ExpInfoWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    },

    onShow: function () {
        this._super();

        if (this.expPriceText) {
            this.expPriceText.setFont(cleverapps.styles.FONTS.HERO_UPGRADE || cleverapps.styles.FONTS.WINDOW_TEXT);
        }
        if (this.coinsPriceText) {
            this.coinsPriceText.setFont(cleverapps.styles.FONTS.HERO_UPGRADE || cleverapps.styles.FONTS.WINDOW_TEXT);
        }
    },

    getStyles: function () {
        return cleverapps.styles.HeroWindow;
    },

    createPriceBlock: function () {
        const styles = this.getStyles();

        const price = new cc.Node();
        price.setAnchorPoint(0.5, 0.5);

        const expPriceText = new TextWithIcon(`%%${this.expPrice}`, {
            font: cleverapps.styles.FONTS.HERO_UPGRADE || cleverapps.styles.FONTS.WINDOW_TEXT,
            icons: {
                "%%": bundles.reward_icons.frames.reward_exp_png
            },
            iconScale: styles.canUpgrade.price.exp.scale
        });

        this.expPriceText = expPriceText;
        price.addChild(expPriceText);

        const coinsPriceText = new TextWithIcon(`%%${this.coinPrice}`, {
            font: cleverapps.styles.FONTS.HERO_UPGRADE || cleverapps.styles.FONTS.WINDOW_TEXT,
            icons: {
                "%%": bundles.reward_icons.frames.reward_gold_png
            },
            iconScale: styles.canUpgrade.price.coin.scale
        });
        this.coinsPriceText = coinsPriceText;
        price.addChild(coinsPriceText);

        cleverapps.UI.arrangeWithMargins(price.children, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.canUpgrade.margin
        });
        cleverapps.UI.wrap(price);

        return price;
    },

    createHelpText: function (message) {
        const styles = this.getStyles();

        // eslint-disable-next-line no-restricted-syntax
        const text = cleverapps.UI.generateTTFText(message, cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
        text.setDimensions(styles.helpBlock.text.width, 0);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_LEFT);

        return text;
    },

    createHelpBlock: function () {
        const styles = this.getStyles();

        const animationNode = new cc.Node();
        animationNode.setAnchorPoint(0.5, 0.5);
        animationNode.setContentSize2(styles.helpBlock.animation);

        const animation = new cleverapps.Spine(bundles.hero_window.jsons.hero_window_help_json);
        animation.setSkin(ColorComponent.CODE_COLORS[this.heroColor]);
        animationNode.addChild(animation);
        animation.setAlignment(styles.helpBlock.animation);
        animation.setAnimation(0, "animation", true);

        const textsLayout = new cleverapps.Layout([this.createHelpText(Messages.get("HeroWindow.help")), this.createHelpText(Messages.get("HeroWindow.help2"))], {
            margin: styles.helpBlock.text.margin,
            direction: cleverapps.UI.VERTICAL
        });

        return new cleverapps.Layout([animationNode, textsLayout], {
            margin: styles.helpBlock.margin,
            direction: cleverapps.UI.HORIZONTAL
        });
    },

    createStatsBlock: function () {
        const styles = this.getStyles();
        const isRTL = cleverapps.UI.isRTL();
        const nextLevel = this.type === "upgrade" || this.type === "unlock";

        const stats = match3.heroes.listStats(this.heroColor, nextLevel);
        const prevStats = this.type === "upgrade" ? match3.heroes.listStats(this.heroColor) : stats;

        const lines = [];

        for (const stat in stats) {
            const cur = stat === "makeHeroProb" ? "%" : "";
            const deltaValue = stats[stat] - prevStats[stat];

            const key = cleverapps.UI.generateOnlyText(Messages.get(`HeroWindow.stats.${stat}`), cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);

            // eslint-disable-next-line no-restricted-syntax
            const valueNode = cleverapps.UI.generateTTFText(
                isRTL ? cur + prevStats[stat] : prevStats[stat] + cur,
                cleverapps.styles.FONTS.HERO_STATS_TEXT || cleverapps.styles.FONTS.WINDOW_SMALL_TEXT
            );
            valueNode.setScale(valueNode.scale * 1.25);
            valueNode.y = styles.statsBlock.digits.dy;

            const items = [key, valueNode];

            if (deltaValue) {
                // eslint-disable-next-line no-restricted-syntax
                const addNode = cleverapps.UI.generateTTFText(
                    `+ ${isRTL ? cur + deltaValue : deltaValue + cur}`,
                    cleverapps.styles.FONTS.HERO_STATS_UPGRADE_VALUE
                );
                addNode.y = styles.statsBlock.digits.dy;
                addNode.setScale(addNode.scale * 1.25);
                isRTL ? items.splice(1, 0, addNode) : items.push(addNode);
            }

            lines.push(new cleverapps.Layout(items, {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.statsBlock.margin,
                reversed: isRTL
            }));
        }

        const activateText = this.createActivateText();
        if (activateText && cleverapps.config.name !== "riddles") {
            lines.push(activateText);
        }

        const statsLayout = new cleverapps.Layout(lines, {
            margin: styles.statsBlock.rowMargin,
            direction: cleverapps.UI.VERTICAL
        });

        lines.forEach((line) => {
            line.setAlignment({ align: "left" }, line.y);
        });
        this.heroView = this.createHero();

        layout = new cleverapps.Layout([this.heroView, statsLayout], {
            margin: styles.statsBlock.heroMargin,
            direction: cleverapps.UI.HORIZONTAL
        });

        return layout;
    },

    createActivateText: function () {
        const styles = this.getStyles().activateText;

        const activateType = match3.heroes.getHero(this.heroColor, {
            nextLevel: (["upgrade", "unlock"].indexOf(this.type) !== -1)
        });
        let prevActivateType = activateType;
        if (this.type === "upgrade") {
            prevActivateType = match3.heroes.getHero(this.heroColor);
        }
        if (activateType.activateByClick !== cleverapps.HERO_ACTIVATE_BY_CLICK_NONE) {
            let s = "Heroes.CanActivateByDblClick";
            if (activateType.activateByClick === cleverapps.HERO_ACTIVATE_BY_CLICK_NO_MOVE) {
                s = "Heroes.CanActivateByDblClickNoMove";
            }
            // eslint-disable-next-line no-restricted-syntax
            const activateText = cleverapps.UI.generateTTFText(Messages.get(s), activateType.activateByClick !== prevActivateType.activateByClick ? cleverapps.styles.FONTS.HERO_STATS_UPGRADE_VALUE : cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
            activateText.setHorizontalAlignment(styles.horizontalAlignment);
            activateText.setDimensions(styles.width, styles.height);
            return activateText;
        }
    },

    createHero: function () {
        const styles = this.getStyles().hero;

        const hero = new cc.Node();
        hero.setLocalZOrder(3);
        hero.setAnchorPoint(0.5, 0.5);
        hero.setContentSize2(styles);

        const color = this.heroColor.toUpperCase();
        const json = cleverapps.skins.getSlot(`${color}_hero_spine_json`) || bundles.heroes.jsons[`${color}_hero_spine_json`];
        const animation = this.animation = new cleverapps.Spine(json);
        animation.setScale(styles.scale);
        animation.setSkin(match3.heroes.getCurrentSkin());
        animation.setAlignment(styles);
        hero.addChild(animation);

        StandartAnimations.rays(hero, {
            skin: cleverapps.config.name === "riddles" ? "blue" : undefined,
            size: styles.raysSize
        });

        return hero;
    },

    generateContent: function () {
        const styles = cleverapps.styles.HeroWindow;

        const items = [];

        const color = this.heroColor.toUpperCase();

        if (this.type === "upgrade" || this.type === "unlock") {
            items.unshift(this.createPriceBlock());
        }

        if (cleverapps.config.name !== "riddles") {
            items.unshift(this.createHelpBlock());
        } else {
            const activateText = this.createActivateText();
            if (activateText) {
                items.unshift(activateText);
            }
        }

        const text = cleverapps.UI.generateOnlyText(Messages.get(`HeroWindow.${color}`), cleverapps.styles.FONTS.HERO_ABILITIES_TEXT || cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.descriptionText.width, styles.descriptionText.height);
        items.unshift(text);

        items.unshift(this.createStatsBlock());

        const layout = new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin,
            padding: styles.padding
        });

        const actions = ["idle", "idle", "out"];
        this.runSequence(this.animation, actions);

        return layout;
    },

    runSequence: function (animation, actions) {
        let index = 0;

        const next = () => {
            const action = actions[index];

            index++;
            if (actions.length === index) {
                index = 0;
            }

            animation.setAnimation(0, action, false);
            animation.setCompleteListener(() => {
                next();
            });
        };

        next();
    },

    listBundles: function () {
        return ["hero_window"];
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    HERO_STATS_UPGRADE_VALUE: {
        size: 30,
        color: cleverapps.styles.COLORS.HERO_STATS_UPGRADE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.HeroWindow = {
    margin: 20,

    canUpgrade: {
        margin: 70,
        price: {
            margin: 10,
            exp: {
                scale: 0.9
            },
            coin: {
                scale: 0.9
            }
        }
    },

    descriptionText: {
        width: 600,
        height: 120
    },

    activateText: {
        horizontalAlignment: cc.TEXT_ALIGNMENT_LEFT,
        width: 350,
        height: 100
    },

    helpBlock: {
        margin: 30,
        text: {
            margin: 50,
            width: 300
        },
        animation: {
            width: 300,
            height: 300,
            x: 150,
            y: 150
        }
    },

    statsBlock: {
        margin: 5,
        rowMargin: 0,
        heroMargin: 40,
        digits: {
            dy: 2
        }
    },

    hero: {
        width: 210,
        height: 210,

        raysSize: 170,

        scale: 1.5,
        x: { align: "center" },
        y: { align: "center", dy: -10 }
    },

    button: {
        width: 300,
        height: 100
    },

    animation: {
        y: 30
    }
};
